import styled from '@emotion/styled';
import React from 'react';

type Size = 'small' | 'default' | 'large';

const sizeMap = {
  small: '8px',
  default: '16px',
  large: '28px',
};

const StyledSpacer = styled.div<SpacerProps>`
  margin-top: ${({ size }): string =>
    size ? sizeMap[size] : sizeMap['default']};
`;

interface SpacerProps {
  size?: Size;
}

export const Spacer: React.FC<SpacerProps> = ({ size }) => (
  <StyledSpacer size={size} />
);
